import { Button } from '@shared/components/ui/button';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface UnauthorizedPageProps {
  message?: string;
}

/**
 * Página que se muestra cuando el usuario no tiene permisos para acceder a un recurso
 */
export const UnauthorizedPage: React.FC<UnauthorizedPageProps> = ({ message }) => {
  const { t } = useTranslation('ui');
  const navigate = useNavigate();

  return (
    <div className="w-full h-full flex items-center justify-center p-6">
      <div className="bg-element-bg text-body-text rounded-lg w-full md:w-1/2 p-8 max-w-[670px] shadow-lg">
        <div className="flex items-center gap-x-6 mb-6">
          <div className="flex items-center justify-center w-20 h-20 rounded-full bg-destructive/10">
            <span className="text-4xl">🚫</span>
          </div>
          <h1 className="font-semibold text-2xl flex flex-col">
            <span className="text-muted-foreground text-sm uppercase tracking-wide">Error</span>
            <span className="font-bold text-5xl text-destructive">403</span>
          </h1>
        </div>
        <h2 className="font-semibold text-xl mb-2">{t('errors.forbidden')}</h2>
        <p className="text-base mb-8 text-muted-foreground">{message || t('errors.message_403')}</p>
        <div className="flex gap-3">
          <Button variant="primary" size="lg" onClick={() => navigate('/')}>
            {t('errors.back_to_home')}
          </Button>
          <Button variant="outline" size="lg" onClick={() => navigate(-1)}>
            {t('common.go_back')}
          </Button>
        </div>
      </div>
    </div>
  );
};
